import ApiService from "../../services/ApiService";
import { finishLogin, getFirebaseUser, auth } from "../../services/firebase";
import { LOG_SEVERITIES, MESSAGES_TYPES, USER_TYPES } from "../../assets/appConstants";
import { postMessage } from "../../services/utils";
import SystemPromptService from "../../services/systemPromptService";
import { ALERTS } from "../common/systemAlert";

export const withCustomToken = (loginRes, customToken) => ({
  ...(loginRes || {}),
  customToken: loginRes?.customToken || customToken,
});

const buildLoginData = (cached, freshLoginRes, accountId, customToken) => ({
  ...cached,
  ...freshLoginRes,
  accountId,
  accountType: freshLoginRes?.accountType || cached?.accountType || USER_TYPES.PATIENT,
  encryptedAccountId: freshLoginRes?.encryptedAccountId || cached?.encryptedAccountId,
  customToken: freshLoginRes?.customToken || cached?.customToken || customToken,
  accountData: null,
  immediateRedirect: true,
});

const finishPatientOnboarding = (loginData) => {
  if (!loginData?.encryptedAccountId || !loginData?.customToken) {
    ApiService.logIt(
      "Patient onboarding: missing auth fields for redirect",
      LOG_SEVERITIES.WARNING,
      loginData
    );
    SystemPromptService.showAlert(ALERTS.GENERIC);
    return;
  }

  finishLogin(loginData);
  postMessage(MESSAGES_TYPES.HIDE_PRELOADER);
};

export const completePatientOnboarding = async ({ accountId, loginContext, customToken }) => {
  const cached = withCustomToken(loginContext, customToken);

  try {
    const user = auth.currentUser || (await getFirebaseUser(cached.customToken));
    const idToken = await user.getIdToken();
    const freshLoginRes = (await ApiService.loginHelper(user.uid, idToken)) || {};

    finishPatientOnboarding(
      buildLoginData(cached, freshLoginRes, user.uid || accountId, customToken)
    );
  } catch (error) {
    ApiService.logIt(
      "Patient onboarding: login-helper refresh failed, using cached session",
      LOG_SEVERITIES.WARNING,
      error
    );
    finishPatientOnboarding(buildLoginData(cached, {}, accountId, customToken));
  }
};
